import {
    CONFIRMED_GET_SETTINGS,
    CONFIRMED_UPDATE_SETTING,
} from "../actions/SettingType";

const initialState = {
    settings: [],
};

export default function settingReducer(state = initialState, action) {
    switch (action.type) {
        case CONFIRMED_GET_SETTINGS:
            return { ...state, settings: action.payload };

        case CONFIRMED_UPDATE_SETTING:
            return {
                ...state,
                settings: state.settings.map((setting) => {
                    const updatedSetting = action.payload.find(
                        (updated) => updated.setting_id === setting.setting_id
                    );
                    return updatedSetting ? { ...setting, ...updatedSetting } : setting;
                }),
            };
        default:
            return state;
    }
}
